import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  const updated = "December 2025";
  return (
    <div className="min-h-screen bg-[var(--c4p-ivory)]">
      <div className="mx-auto max-w-3xl px-6 py-16 lg:px-0 lg:py-24">
        <Link
          to="/"
          data-testid="back-home-link"
          className="inline-flex items-center gap-2 font-sans-ui text-[13px] font-semibold text-[var(--c4p-forest)] hover:text-[var(--c4p-orange)]"
        >
          <ArrowLeft size={14} /> Back to home
        </Link>

        <h1 className="font-display mt-8 text-[44px] leading-[1.02] sm:text-[60px]">
          Terms of{" "}
          <span className="font-display-italic text-[var(--c4p-orange)]">Service.</span>
        </h1>
        <p className="mt-4 font-sans-ui text-[13px] text-[var(--c4p-muted)]">
          Last updated: {updated}
        </p>

        <div className="mt-10 space-y-8 font-sans-ui text-[15px] leading-relaxed text-[var(--c4p-ink)]/85">
          <section>
            <h2 className="font-display text-[22px] text-[var(--c4p-forest)]">1. Agreement</h2>
            <p className="mt-3">
              By using cash-4-properties.com (the "Site") or submitting a form,
              you agree to these Terms of Service. If you do not agree, please
              do not use the Site.
            </p>
          </section>

          <section>
            <h2 className="font-display text-[22px] text-[var(--c4p-forest)]">2. Not a licensed real-estate broker</h2>
            <p className="mt-3">
              Cash 4 Properties is a real-estate investor. We are not acting as
              a real-estate broker, agent, or attorney. We do not list
              properties on the MLS or represent you in a sale to another
              party. If you want professional representation, we encourage you
              to consult a licensed broker or attorney.
            </p>
          </section>

          <section>
            <h2 className="font-display text-[22px] text-[var(--c4p-forest)]">3. Cash offers are non-binding until signed</h2>
            <p className="mt-3">
              Any verbal or written cash offer we provide is an invitation to
              treat — not a binding contract. A binding agreement exists only
              when both parties sign a written purchase agreement meeting the
              requirements of North Carolina law. Offers are subject to change
              based on title review, inspection, or material facts not
              disclosed in the initial inquiry.
            </p>
          </section>

          <section>
            <h2 className="font-display text-[22px] text-[var(--c4p-forest)]">4. Your representations</h2>
            <p className="mt-3">You represent that:</p>
            <ul className="mt-3 list-disc space-y-1 pl-6">
              <li>You are at least 18 years old</li>
              <li>You are the legal owner of the property you submit, or authorized by the owner</li>
              <li>The information you provide is truthful and accurate</li>
              <li>The property is not currently listed with a real-estate broker (or you have already notified us it is)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-[22px] text-[var(--c4p-forest)]">5. No obligation</h2>
            <p className="mt-3">
              Requesting an offer is 100% free and places no obligation on you
              to sell. We may, in our sole discretion, decline to make an offer
              on any property.
            </p>
          </section>

          <section>
            <h2 className="font-display text-[22px] text-[var(--c4p-forest)]">6. Website use</h2>
            <p className="mt-3">You agree not to:</p>
            <ul className="mt-3 list-disc space-y-1 pl-6">
              <li>Submit false or misleading information</li>
              <li>Scrape, crawl, or misuse the Site</li>
              <li>Attempt to circumvent our spam-protection (reCAPTCHA)</li>
              <li>Use the Site for unlawful purposes</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-[22px] text-[var(--c4p-forest)]">7. Intellectual property</h2>
            <p className="mt-3">
              All content on the Site — text, graphics, logos, and layout — is
              owned by Cash 4 Properties or its licensors. You may view and
              share it, but you may not copy, sell, or republish it without our
              permission.
            </p>
          </section>

          <section>
            <h2 className="font-display text-[22px] text-[var(--c4p-forest)]">8. Disclaimer & limitation of liability</h2>
            <p className="mt-3">
              The Site is provided "as is." To the maximum extent allowed by
              law, Cash 4 Properties is not liable for any indirect,
              incidental, special, or consequential damages, or for loss of
              profits, arising out of or in connection with your use of the
              Site or any offer.
            </p>
          </section>

          <section>
            <h2 className="font-display text-[22px] text-[var(--c4p-forest)]">9. Governing law & venue</h2>
            <p className="mt-3">
              These Terms are governed by the laws of the State of North
              Carolina, without regard to conflicts-of-law rules. Any dispute
              will be resolved exclusively in the state or federal courts
              located in North Carolina.
            </p>
          </section>

          <section>
            <h2 className="font-display text-[22px] text-[var(--c4p-forest)]">10. Changes</h2>
            <p className="mt-3">
              We may modify these Terms at any time. Continued use of the Site
              after a change means you accept the updated Terms.
            </p>
          </section>

          <section>
            <h2 className="font-display text-[22px] text-[var(--c4p-forest)]">11. Contact</h2>
            <p className="mt-3">
              Cash 4 Properties — Eastern North Carolina. Phone (910) 212-5006,
              email{" "}
              <a className="underline" href="mailto:triston@cash-4-properties.com">
                triston@cash-4-properties.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
